import AppBar from '@/components/appBar';
import { showConfirm } from '@/utils/utils';
import { useLocation, useNavigate } from 'react-router-dom';
import Page from '../../components/page';

export default function IframePage() {
  const location = useLocation();
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // url 跳转的外部链接 title页面标题 pay 是否支付跳转 back活动页面和充值页面完成后再后退
  const { url, title, back } = location.state;

  async function handlePayBack() {
    navigate(-2);
    await showConfirm({
      title: '提示',
      content: '是否支付完成?',
      confirmBtnText: '支付完成',
      cancelBtnText: '未完成',
    });
    if (back) {
      navigate(-1);
    } else {
      navigate('/select-pack', { replace: true });
    }
  }

  return (
    <Page
      appBar={<AppBar title="支付结果" onBack={() => handlePayBack()}></AppBar>}
      className="customer-page-show-title bw-100 vh-100"
      contentClassName="bw-100 vh-100"
    >
      <iframe className="bw-100 bh-100 border-none" title={title ?? '支付结果'} src={url} />
    </Page>
  );
}
